import React from "react";
import { ChooseCompany } from "components/ChooseCompany";

export const LandingPage = () => {
  return (
    <ChooseCompany />
  );
};